const hamburger = document.querySelector('.main-menu__hamburger');
const top = document.querySelector('.header__topbar');

hamburger.addEventListener('click', () => {
    top.classList.toggle('main-menu__hamburger--open');
    document.body.classList.toggle('body-overflow');
})